import React from "react";

const CancelConfirmModal = ({
    show,
    close,
    confirm,
    loading,
}) => {
    if (!show) return null;

    return (
        <div className="modal-overlay-history">
            <div className="modal-box">
                <h3>Cancel Order</h3>
                <p>
                    Are you sure you want to cancel
                    this order?
                </p>

                <div className="modal-actions">
                    <button
                        onClick={close}
                        disabled={loading}
                    >
                        DON'T CANCEL
                    </button>

                    <button
                        className="proceed"
                        onClick={confirm}
                        disabled={loading}
                    >
                        {loading
                            ? "Processing..."
                            : "CONFIRM CANCEL"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelConfirmModal;